import React from "react";
import { formatConsensusDelta } from "../../utils/consensusComparison";
import "./ConsensusComparisonBadge.css";

function consensusTone(delta) {
  if (delta == null || !Number.isFinite(delta)) return "neutral";
  if (delta > 0) return "bullish";
  if (delta < 0) return "bearish";
  return "match";
}

function consensusTitle(comparison) {
  if (!comparison) return "No consensus rank available";
  if (comparison.delta === 0) return "Matches consensus rank";
  if (comparison.delta > 0) {
    return `Ranked ${comparison.delta} spot${comparison.delta === 1 ? "" : "s"} higher than consensus`;
  }
  return `Ranked ${Math.abs(comparison.delta)} spot${
    Math.abs(comparison.delta) === 1 ? "" : "s"
  } lower than consensus`;
}

/**
 * @param {object} props
 * @param {{ consensusRank: number, delta: number }|null} props.comparison
 * @param {"card"|"list"} [props.variant]
 */
function ConsensusComparisonBadge({ comparison, variant = "card" }) {
  const tone = comparison ? consensusTone(comparison.delta) : "na";
  const deltaLabel = comparison ? formatConsensusDelta(comparison.delta) : null;
  const isOverlay = variant === "card";

  return (
    <span
      className={[
        "consensus-comparison",
        `consensus-comparison--${tone}`,
        `consensus-comparison--${variant}`,
        isOverlay ? "consensus-comparison--overlay" : "",
        variant === "list" ? "consensus-comparison--panel" : "",
      ].join(" ")}
      title={consensusTitle(comparison)}
    >
      <span className="consensus-comparison-heading">Consensus</span>
      <span className="consensus-comparison-values">
        <span className="consensus-comparison-rank">
          {comparison?.consensusRank != null ? `#${comparison.consensusRank}` : "N/A"}
        </span>
        {deltaLabel && (
          <span className="consensus-comparison-delta">{deltaLabel}</span>
        )}
      </span>
    </span>
  );
}

export default ConsensusComparisonBadge;
